import { GetListResponse, instance } from "libs/api";

import { ProductsListItem } from "../../product.types";
import { ApiRoutesProducts } from "./../../constants/enums";
import { GetProductsByFilterBody } from "./getProductsByFilter.types";

export const requestGetProductsByFilter = async (
  body: GetProductsByFilterBody
): Promise<GetListResponse<ProductsListItem>> => {
  return await instance.post(ApiRoutesProducts.AllProducts, body);
};
